import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import msTranslations from '../../locales/ms.json';

i18n
  .use(initReactI18next)
  .init({
    lng: 'ms',
    fallbackLng: 'ms',
    supportedLngs: ['ms'],

    resources: {
      ms: {
        translation: msTranslations,
        ...msTranslations
      }
    },
    defaultNS: 'translation',

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
